import { BaseFilterListResponseModel } from "app/based/baseApiModel/baseFilterListModel/BaseFilterListResponseModel";
import { TempCarrierId } from "features/airTimeManagement/presentation/constants/AirTimeManagementConstants";

export class AirtimeResponseEntity {
  createAt?: string;
  updateAt?: string;
  id?: string;
  name?: string;
  code?: string;
  amount?: string;
  status?: number;
  type?: number;
  description?: string;
  config?: string;
  order?: number;
  carrier?: string;

  static mapCarrierWithId(data: Array<BaseFilterListResponseModel>) {
    return data?.map((item) => ({
      id: TempCarrierId[item?.code],
      ...item,
    }));
  }
}
